import type { CateringDraftOrderStatus } from 'models/CateringDraftOrder';

interface StatusConfig {
  label: string;
  colors: { background: string; text: string };
  pillType: 'error' | 'success' | '';
}

const CATERING_DRAFT_ORDER_STATUS_CONFIG: Record<CateringDraftOrderStatus, StatusConfig> = {
  pending: { label: 'Draft - Pending Review', colors: { background: '#E2E3E5', text: '#383D41' }, pillType: '' },
  accepted: { label: 'Draft - Accepted', colors: { background: '#D4EDDA', text: '#155724' }, pillType: 'success' },
  rejected: { label: 'Draft - Rejected', colors: { background: '#E2E3E5', text: '#383D41' }, pillType: '' },
  finalizing: { label: 'Processing...', colors: { background: '#E2E3E5', text: '#383D41' }, pillType: '' },
  finalized: { label: 'Finalized', colors: { background: '#D4EDDA', text: '#155724' }, pillType: 'success' },
  cancelled: { label: 'Draft - Cancelled', colors: { background: '#F8D7DA', text: '#721C24' }, pillType: 'error' },
};

function isKnownStatus(status: string | undefined): status is CateringDraftOrderStatus {
  return !!status && status in CATERING_DRAFT_ORDER_STATUS_CONFIG;
}

function getConfig(status?: string): StatusConfig | null {
  return isKnownStatus(status) ? CATERING_DRAFT_ORDER_STATUS_CONFIG[status] : null;
}

export function getCateringDraftOrderStatusColors(status?: string): { background: string; text: string } {
  return getConfig(status)?.colors ?? CATERING_DRAFT_ORDER_STATUS_CONFIG.pending.colors;
}

export function getCateringDraftOrderStatusPillType(status?: string): 'error' | 'success' | '' {
  return getConfig(status)?.pillType ?? '';
}

type CateringDraftStatusLabelMap = Record<CateringDraftOrderStatus, string>;

export const CATERING_DRAFT_ORDER_STATUS_LABELS: CateringDraftStatusLabelMap = Object.fromEntries(
  Object.entries(CATERING_DRAFT_ORDER_STATUS_CONFIG).map(([k, v]) => [k, v.label])
) as CateringDraftStatusLabelMap;

export const CATERING_DRAFT_ORDER_TYPE = 'draft';

export function getCateringDraftOrderPrettyName(draftStatus?: CateringDraftOrderStatus): string {
  return (draftStatus && CATERING_DRAFT_ORDER_STATUS_LABELS[draftStatus]) || 'Draft';
}
